/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import template from './views/class_average.html';
import controller from './controllers/classaverageController';
var module = angular.module('academicPerformance', [
    //import modules
]).controller('academicPerformance', controller);

module.constant('academicPerformance', {
})
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('academicPerformance', {
//             parent: 'app',
//             url: '/academic-performance',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'academicPerformance'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/educore_reports/school/class_averageModule.js